// Bundle fontawesome css.
import '@fortawesome/fontawesome-svg-core/styles.css';
import { config } from '@fortawesome/fontawesome-svg-core';
// Prevent fontawesome from dynamically adding its css.
config.autoAddCss = false;

require('typeface-quicksand');
require('typeface-source-sans-pro');
